import { render } from "./NewView.vue?vue&type=template&id=692c2230"
import script from "./NewView.vue?vue&type=script&lang=js"
export * from "./NewView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__